//handles save from the user info form post, show either the multi-select list or goto transition page. req contains json of full request data, pass it on to next step.  
function onRFPUserInfoSaved(req, bShowMulti, bShowEMail) {

    if (bShowEMail)
    {
        window.parent.$(".rfp-select-paragraph").hide();
    } else{
         // Close the user modal and wait until fully hidden to do next step
        const $parent = window.parent.$;
        const modal = $parent('#rfpUserInfoModal');
        modal.one('hidden.bs.modal', function () {
            // Now safe to open the next modal or navigate         
             $("#rfpUserInfoFrame").attr("src", "");
            if (bShowMulti) {
                window.parent.openMultiRfp(req);   
            } else if (req!="") {
                window.parent.postToRfpPage(req);
            }
        });

        // Trigger the hide (asynchronously)
        modal.modal('hide');
    }
    return;
    

}

//opens the multiple select modal passing in request that has selected hotel and pagekey or the previous request from the user reg form
function openMultiRfp(req) {

    var DTO = { req: req };

    DynaProxy.invoke("GetMultiRFP", DTO, function (data) {
        $(".rfp-multi-list").html(data);
        $("#rfpMultiselectModal").modal('show');
    }, AjaxFailed);
}                      



function sendRFPEMail(req) {

    var DTO = { req: req };

    DynaProxy.invoke("SendRFPEMail", DTO, function (data) {
        $(".rfp-email-success").show();
         $(".rfp-hotel-list,.rfp-select-feature-button,.signup-message").hide();
    }, AjaxFailed);
}                      


function postToRfpPage(req) {

    var url =   "/RFP/default.aspx";

    var form = document.createElement("form");
    form.method = "post";
    form.action = url;
    form.target = "_blank"; 
    function add(name, value) {
        if (value === undefined || value === null) return;
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    // form fields (body)
    add("RID", req.RID);         
    add("RequestId", req.RequestId);
    add("FirstName", req.FirstName);
    add("LastName", req.LastName);
    add("Email", req.Email);
    add("Phone", req.Phone);
    add("Company", req.Company);
    add("Title", req.Title);
    add("City", req.City);
    add("EventToPlan", req.EventToPlan);
    add("Provider", req.Provider);      
    add("UserUniqueID", req.UserUniqueID);      
    add("PageKey", req.PageKey);

    document.body.appendChild(form);
    form.submit();
}

$(function () {
    $(".rfp-venue-itm").on("click", function (event) {
       event.preventDefault();
       var req={PageKey:globalThis.gaPagekey,RID:$(this).data("rid")}
       postToRfpPage(req);
    });

    
    $(document).on("click", ".rfp-email-modal-close", function (event) {
        event.preventDefault();
        const $parent = window.parent.$;
        const modal = $parent('#rfpUserInfoModal');
        modal.modal('hide');
         $("#rfpUserInfoFrame").attr("src", "");

        const modal2 = $('#rfpMultiselectModal');
        modal2.modal('hide');

        return;
    });

    
    $(document).on("click", ".rfp-venue-itm-user", function (event) {
        event.preventDefault();
        var encryptedKey = $(this).data("rid");

        if (encryptedKey) {
            var url = "/RFP/User/Default.aspx?rid=" + encodeURIComponent(encryptedKey) + "&p=" + globalThis.gaPagekey;
            $("#rfpUserInfoFrame").attr("src", url);
             
            var DTO = { 'rid': encryptedKey }
            DynaProxy.invoke("RFPRenderUserInfo", DTO, function (data) {
                var $container = $(".rfp-user-info");
                $container.find('.rfp-userinfo-result').remove();
                $container.prepend('<div class="rfp-userinfo-result">' + data + '</div>');
                $("#rfpUserInfoModal").modal('show')

            }, AjaxFailed);
        }
    }); 

    $(document).on("click", ".rfp-venue-itm-multi", function (event) {
         event.preventDefault();                
        var req= {RID:$(this).data("rid"),PageKey:globalThis.gaPagekey};         
        openMultiRfp(req)
    });

 
    $(document).on("click", ".rfp-multi-venue-continue", function (event) {
        //if ( $(".rfp-multi-venue-checkbox:checked").length>5){
        //    alert('Please select less than 5 additional hotels');
        //    return;
        //}

        event.preventDefault();   

        var req = $(this).data("reqinfo");
        try { req = JSON.parse(req); } catch {}

        //Get all checked checkboxes and set in request
        var selectedRids = $(".rfp-multi-venue-checkbox:checked")
            .map(function () {
                return $(this).val();
            }).get();        
        var primaryRid = $(this).data("rid"); //Add primary venue
        selectedRids.unshift(primaryRid); //include primary venue at the beginning 

        req.RID=   selectedRids.join(","); //rewrite with new selections
        
        if ($(this).data("email")=="1"){
            sendRFPEMail(req);
        }
        else{
            $("#rfpMultiselectModal").modal('hide');
            postToRfpPage(req);
        }
    });

       //$(document).on("change", ".rfp-multi-venue-checkbox", function () {
    //    var max = 5;
    //    var checkedCount = $(".rfp-multi-venue-checkbox:checked").length;

    //    if (checkedCount >= max) {
    //        // Disable unchecked checkboxes
    //        $(".rfp-multi-venue-checkbox:not(:checked)").prop("disabled", true);
    //    } else {
    //        // Re-enable all checkboxes
    //        $(".rfp-multi-venue-checkbox").prop("disabled", false);
    //    }
    //});

        

});
